module.exports = __webpack_public_path__ + "static/media/image.25beb4ac.svg";